/**
 * Values learned after the history batch, keyed by pill id. Returns the same map when the list
 * is unchanged so a chip re-render does not start another lookup.
 */
export const replaceRegisteredWorkspaceAgentKeyedList = <Item>(
  current: ReadonlyMap<string, readonly Item[]>,
  key: string,
  items: readonly Item[],
): ReadonlyMap<string, readonly Item[]> => {
  const previous = current.get(key);

  if (previous?.length === items.length && previous.every((item, index) => Object.is(item, items[index]))) {
    return current;
  }

  const next = new Map(current);
  next.set(key, items);

  return next;
};

export const replaceRegisteredWorkspaceAgentClipIds = (
  current: ReadonlyMap<string, readonly string[]>,
  key: string,
  clipIds: readonly string[],
): ReadonlyMap<string, readonly string[]> => replaceRegisteredWorkspaceAgentKeyedList(current, key, clipIds);
